<template>
  <div id="pop">
    <!-- 111111111111111 -->
    <van-popup get-container="#popup" v-model="show" position="right" :style="{ height: '100%' }" class="popup-van" :closeable="false" @close="closeFun">
      <div class="fen0">
        <div class="fen1 mr6">
          <div class="fen1-1">商品状态</div>
          <ul class="ul ul1">
            <li v-for="(item, index) of upselfList" :key="item.name" :class="['van-ellipsis', item.select ? 'active' : '', 'fen1-2']" @click="upselfClick(item, index)">
              {{ item.name }}<img src="@/assets/image/mode-active.png" alt="" />
            </li>
          </ul>
        </div>
        <div class="fen1 mr6">
          <div class="fen1-1">价格</div>
          <div class="fen1-3 mt-3">
            <!-- @touchstart.native.stop="showKeyb = true" readonly -->
            <van-field class="fen1-3-1" v-model="min" type="number"  clickable placeholder="最低价" />
            <van-number-keyboard z-index="2020" v-model="min" :show="showKeyb" :maxlength="6" @blur="showKeyb = false" />
            <span class="fen1-3-2">-</span>
            <!-- @touchstart.native.stop="showKeyc = true" readonly -->
            <van-field class="fen1-3-1" v-model="max" type="number" clickable placeholder="最高价" />
            <van-number-keyboard z-index="2020" v-model="max" :show="showKeyc" :maxlength="6" @blur="showKeyc = false" />
            
          </div>
          <ul class="ul ul1">
            <li @click="setInputFun('100', '300')" class="fen1-4">
              <span>100-300</span>
            </li>
            <li @click="setInputFun('300', '500')" class="fen1-4">
              <span>300-500</span>
            </li>
            <li @click="setInputFun('500', '1000')" class="fen1-4" style="margin-right: 5px">
              <span>500-1000</span>
            </li>
            <li @click="setInputFun('1000', '')" class="fen1-4">
              <span>1000以上</span>
            </li>
          </ul>
        </div>
        <div class="fen1 category">
          <div class="fen1-1">品类</div>
          <ul class="ul">
            <li class="fen1-2" @click="getCorte('1')">
              <span class="van-ellipsis sp1">{{ categoryForm1.categoryName || "请选择" }}</span>
              <van-icon class="sp2" size="14" name="arrow-down" />
            </li>
            <li v-if="categoryList2.length > 0" class="van-ellipsis fen1-2" @click="getCorte('2')">
              <span class="van-ellipsis sp1">{{ categoryForm2.categoryName || "请选择" }}</span>
              <van-icon class="sp2" size="14" name="arrow-down" />
            </li>
            <li v-if="categoryList2.length == 0 && categoryForm1.id" class="van-ellipsis fen1-2">
              {{ categoryForm2.categoryName }}
            </li>
            <li v-if="categoryList3.length > 0" class="van-ellipsis fen1-2" @click="getCorte('3')">
              <span class="van-ellipsis sp1">{{ categoryForm3.categoryName || "请选择" }}</span>
              <van-icon class="sp2" size="14" name="arrow-down" />
            </li>
            <li v-if="categoryList3.length == 0 && categoryForm2.id" class="van-ellipsis fen1-2">
              {{ categoryForm3.categoryName }}
            </li>
          </ul>
        </div>
        <!-- <div class="fen1 mr6">
          <div class="fen1-1">品牌</div>
          <ul class="ul ul1">
            <li @click="branchSelectFun(item)" v-for="item in branchList" :key="item.id" class="van-ellipsis" :class="[item.select ? 'active' : '', 'fen1-2']">
              {{item.brandName}}<img src="@/assets/image/mode-active.png" alt="" />
            </li>
          </ul>
        </div> -->
        <div class="fen1 mr6">
          <div class="fen1-1">类型筛选</div>
          <ul class="ul ul1">
            <!-- <li
              @click="branchSelectFun(item)"
              v-for="item in branchList"
              :key="item.id"
              class="van-ellipsis"
              :class="[item.select ? 'active' : '', 'fen1-2']"
            >{{item.brandName}}<img src="@/assets/image/mode-active.png" alt=""></li> -->
            <li v-for="(item, index) of publishes" :key="item.name" :class="['van-ellipsis', item.select ? 'active' : '', 'fen1-2']" @click="onStockSourceClick(item, index)">
              {{ item.name }}<img src="@/assets/image/mode-active.png" alt="" />
            </li>
          </ul>
        </div>

        <div class="fen1 mr6">
          <div class="fen1-1">活动时间</div>
          <div class="fen1-3 mt-3">
            <van-field class="fen1-3-1" :value="form.promotionStartTime" @click="showStartTime = true" readonly clickable placeholder="开始时间" />
            <van-popup v-model="showStartTime" position="bottom" get-container="#pop">
              <van-datetime-picker type="date" title="选择年月日" @confirm="startTimeChange" @cancel="showStartTime=false" />
            </van-popup>

            <span class="fen1-3-2">-</span>
            <van-field class="fen1-3-1" :value="form.promotionEndTime" @click="showEndTime = true" readonly clickable placeholder="结束时间" />
            <van-popup v-model="showEndTime" position="bottom" get-container="#pop">
              <van-datetime-picker type="date" title="选择年月日" @confirm="endTimeChange" @cancel="showEndTime=false" />
            </van-popup>
          </div>
        </div>

        <div class="fen1 mr6">
          <div class="fen1-1">活动类型</div>
          <ul class="ul ul1">
            <li @click="promotionTypeSelectFun(item)" v-for="item in promotionTypeOpt" :key="item.key" class="van-ellipsis" :class="[item.select ? 'active' : '', 'fen1-2']">
              {{item.name}}<img src="@/assets/image/mode-active.png" alt="" />
            </li>
          </ul>
        </div>


        <div v-if="open">
          <div class="fen1 category filter-item">
          <div class="fen1-1">商品完善情况</div>
          <ul class="ul" v-for="(item,idx) in conditions" :key="idx">
            <li class="fen1-2" @click="openFilterType(idx)">
              <span class="van-ellipsis sp1">{{ item.type.title || "筛选项" }}</span>
              <van-icon class="sp2" size="14" name="arrow-down" />
            </li>
            <li class="van-ellipsis fen1-2" @click="openFilterRange(idx,'conditions')">
              <span class="van-ellipsis sp1">{{ item.range.title || "条件"  }}</span>
              <van-icon class="sp2" size="14" name="arrow-down" />
            </li>
            <!-- <li class="van-ellipsis fen1-2" @click="openFilterValue(idx)">
              <span class="van-ellipsis sp1">{{ item.value || "请输入" }}</span>
            </li> -->
            <li class="van-ellipsis fen1-2">
              <input type="text" v-model="item.value" class="ellipsis-input" placeholder="请输入"/>
            </li>

            <img src="../../../assets/image/sub@2x.png" class="del-icon" @click="delList(idx,'conditions')" v-if="idx > 0" />
          </ul>
          <ul class="ul">
            <li class="fen1-2 add-btn" @click="addList('conditions')">
              <span class="van-ellipsis sp1 ">+添加</span>
            </li>
          </ul>
        </div>
        <van-popup get-container="#pop" v-model="showFilterType" position="bottom">
          <van-picker show-toolbar :columns="filterItems" @confirm="onConfirmFilterType($event, 1)" @cancel="showFilterType = false" value-key="title" />
        </van-popup>

        <van-popup get-container="#pop" v-model="showFilterRange" position="bottom">
          <van-picker show-toolbar :columns="filterConditions" @confirm="onConfirmFilterRange($event)" @cancel="showFilterRange = false" value-key="title" />
        </van-popup>

        <van-popup v-model="showFilterValue" get-container="#pop" class="num-popup">
          <van-field v-model="text" label="文本" placeholder="请输入用户名" />
          <button class="button confirm" type="warning" @click="onConfirmFilterValue">
            确认
          </button>
        </van-popup>

        <!-- 1111111111111 -->
        <div class="fen1 category filter-item">
          <div class="fen1-1">库存情况</div>
          <ul class="ul" v-for="(item,idx) in inventoryList" :key="idx">
            <li class="fen1-2" @click="openInventoryType(idx)">

              <span class="van-ellipsis sp1">{{ item.type.title || "筛选项" }}</span>
              <van-icon class="sp2" size="14" name="arrow-down" />
            </li>
            <li class="van-ellipsis fen1-2" @click="openFilterRange(idx,'inventory')">
              <span class="van-ellipsis sp1">{{ item.range.title || "条件"  }}</span>
              <van-icon class="sp2" size="14" name="arrow-down" />
            </li>
            <!-- <li class="van-ellipsis fen1-2" @click="openFilterValue(idx)">
              <span class="van-ellipsis sp1">{{ item.value || "请输入" }}</span>
            </li> -->
            <li class="van-ellipsis fen1-2" >
              <input type="text" v-model="item.value" class="ellipsis-input " placeholder="请输入"/>
            </li>
            <img src="../../../assets/image/sub@2x.png" class="del-icon" @click="delList(idx,'inventory')" v-if="idx > 0" />
          </ul>
          <ul class="ul">
            <li class="fen1-2 add-btn" @click="addList('inventory')">
              <span class="van-ellipsis sp1">+添加</span>
            </li>
          </ul>
        </div>
        <van-popup get-container="#pop" v-model="showInventoryType" position="bottom">
          <van-picker show-toolbar :columns="filterInventory" @confirm="onConfirmInventoryType($event)" @cancel="showInventoryType = false" value-key="title" />
        </van-popup>

        <div class="fen1 mr6">
          <div class="fen1-1">库存100商品来源</div>
          <ul class="ul ul1">
            <li v-for="(item, index) of stockSourceOpt" :key="item.name" :class="['van-ellipsis', item.select ? 'active' : '', 'fen1-2']" @click="onPublishItemClick(item, index)">
              {{ item.name }}<img src="@/assets/image/mode-active.png" alt="" />
            </li>
          </ul>
        </div>
        </div>


        <div @click="open = !open" class="open-view">
          更多筛选
          <img :class="open?'img_single':'img'" :src="open ? single_down : single_up" alt="">
        </div>

      </div>

      <div class="navbar-fixed index-popup-confirm">
        <button class="button" type="default" @click="resetFun">重 置</button>
        <button class="button confirm" type="warning" @click="emitFun">
          确认
        </button>
      </div>
    </van-popup>

    <van-popup get-container="#pop" v-model="showPicker1" position="bottom">
      <van-picker show-toolbar :columns="categoryList1" @confirm="onConfirm($event, 1)" @cancel="showPicker1 = false" />
    </van-popup>
    <van-popup get-container="#pop" v-model="showPicker2" position="bottom">
      <van-picker show-toolbar :columns="categoryList2" @confirm="onConfirm($event, 2)" @cancel="showPicker2 = false" />
    </van-popup>
    <van-popup get-container="#pop" v-model="showPicker3" position="bottom">
      <van-picker show-toolbar :columns="categoryList3" @confirm="onConfirm($event, 3)" @cancel="showPicker3 = false" />
    </van-popup>
  </div>
</template>
<script>
import http from "@/utils/axios";
import M from "minimatch";
export default {
  name: "beeAdministrate-list-mode",
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
      required: false,
    },
  },
  data() {
    return {
      open: false,
      single_down: require('@/assets/brand/xia2x.png'),
      single_up: require('@/assets/brand/sha@2x.png'),

      branchNo: "",
      // promotionStartTime: "",
      form: {
        promotionStartTime: "",
        promotionEndTime: "",
        promotionType: []
      },
      showStartTime: false,
      showEndTime: false,

      conditions: [{ type: {}, range: {}, value: "" }],
      filterIndex: 0,
      showFilterType: false,
      filterRangeType: "",
      showFilterRange: false,
      showFilterValue: false,
      text: "",

      inventoryList: [{ type: {}, range: {}, value: "" }],
      inventoryIndex: 0,
      showInventoryType: false,


      isSuper: false,
      show: false,
      showPicker1: false,
      showPicker2: false,
      showPicker3: false,
      min: "",
      showKeyb: false,
      max: "",
      showKeyc: false,
      categoryList1: [],
      formList1: {},
      categoryForm1: { categoryName: "", id: "" },
      categoryList2: [],
      formList2: {},
      categoryForm2: { categoryName: "", id: "" },
      categoryList3: [],
      formList3: {},
      categoryForm3: { categoryName: "", id: "" },
      chidList: {},
      branchList: [],
      publishes: [
        { name: "我发布的", select: false },
        { name: "置顶商品", select: false },
      ],
      upselfList: [
        { key:'y',name: "已上架", select: false },
        { key:'n', name: "已下架", select: false },
      ],


      promotionTypeOpt: [
        { key: "2", name: "调价活动", select: false },
        { key: "1", name: "满减满折活动", select: false },
        { key: "5", name: "满赠活动", select: false },
      ],
      // 1-封面图数量,2-头图数,3-详情图片数,4-主规格数,5-规格图缺失数,6-标题字数,7-销售价,8-折扣,9-重量,10-库存量,11-吊牌价,12-商品创建时间
      filterItems: [
        { title: "封面图数量", type: 'surfaceImage', key: "1" },
        { title: "头图数", type: 'mainImage', key: "2" },
        { title: "详情图片数", type: 'detailImage', key: "3" },
        { title: "主规格数", type: 'mainSpec', key: "4" },
        { title: "规格图缺失数", type: 'specLose', key: "5" },
        { title: "标题字数", type: 'title', key: "6" },
        { title: "销售价", type: 'price', key: "7" },
        { title: "划线价", type: 'markingPrice', key: "11" },
        { title: "折扣", type: 'discount', key: "8" },
        { title: "重量", type: 'weight', key: "9" },
      ],
      filterInventory: [
        { title: "库存量", key: "10" },
      ],

      // 0-无，1-大于，2-大于等于，3-等于，4-小于等于，5-小于
      // filterConditions: ["无折扣", "大于", "大于等于", "等于", "小于等于", "小于"],
      filterConditions: [
        { title: "无折扣", key: "0" },
        { title: "大于", key: "1" },
        { title: "大于等于", key: "2" },
        { title: "等于", key: "3" },
        { title: "小于等于", key: "4" },
        { title: "小于", key: "5" },
      ],
      // 0 全部 1虚拟 2真实
      stockSourceOpt: [
        { key: "1", name: "虚拟erp", select: false },
        { key: "2", name: "真实erp", select: false },
      ]

    };
  },
  methods: {
    // 库存
    openInventoryType(index) {
      this.inventoryIndex = index
      this.showInventoryType = true
    },
    onConfirmInventoryType(e) {
      console.log(e);
      this.inventoryList[this.inventoryIndex].type = e
      this.showInventoryType = false
    },
    openFilterValue(index) {
      this.filterIndex = index
      this.showFilterValue = true

    },
    onConfirmFilterValue() {
      console.log(this.text);
      this.conditions[this.filterIndex].value = this.text
      this.text = ""
      this.showFilterValue = false
    },
    openFilterRange(index, type) {
      if (type == 'conditions') {
        this.filterIndex = index
      }
      if (type == 'inventory') {
        this.inventoryIndex = index
      }
      this.filterRangeType = type
      this.showFilterRange = true
    },
    onConfirmFilterRange(e) {
      console.log(e);
      if (this.filterRangeType == 'conditions') {
        this.conditions[this.filterIndex].range = e
      }
      if (this.filterRangeType == 'inventory') {
        this.inventoryList[this.inventoryIndex].range = e
      }
      this.showFilterRange = false
    },
    addList(type) {
      if (type == 'conditions') {
        this.conditions.push({ type: {}, range: {}, value: "" })
      }
      if (type == 'inventory') {
        this.inventoryList.push({ type: {}, range: {}, value: "" })
      }
    },
    delList(idx, type) {
      if (type == 'conditions') {
        this.conditions.splice(idx, 1)
      }
      if (type == 'inventory') {
        this.inventoryList.splice(idx, 1)
      }
    },
    openFilterType(index) {
      this.filterIndex = index
      this.showFilterType = true
    },
    onConfirmFilterType(e) {
      console.log(e);
      this.conditions[this.filterIndex].type = e
      this.showFilterType = false
    },

    // 开始时间
    startTimeChange(date) {
      this.form.promotionStartTime = this.getDate(date)
      this.showStartTime = false
    },
    // 结束时间
    endTimeChange(date) {
      this.form.promotionEndTime = this.getDate(date)
      this.showEndTime = false
    },
    getDate(date) {
      return date.toLocaleDateString().replace(/\//g, "-")
    },
    // 活动类型
    promotionTypeSelectFun(item) {
      console.log(item);
      item.select = !item.select;
    },

    closeFun() {
      this.show = false;
      this.$emit("callbackClose", false);
    },
    onConfirm(value, tab) {
      console.log(value, tab);
      let obj2 = tab + 1;
      let obj3 = tab + 2;
      this["categoryForm" + tab] &&
        (this["categoryForm" + tab] = { categoryName: "", id: "" });
      this["categoryForm" + obj2] &&
        (this["categoryForm" + obj2] = { categoryName: "", id: "" });
      this["categoryForm" + obj3] &&
        (this["categoryForm" + obj3] = { categoryName: "", id: "" });
      this["categoryForm" + tab].categoryName = value;
      this["categoryForm" + tab].id = this["formList" + tab][value];
      this["showPicker" + tab] = false;
      tab != 3 &&
        this["categoryForm" + tab].id &&
        this.findChindCategory(tab + 1, this["categoryForm" + tab].id);
    },
    getCorte(tab) {
      this["showPicker" + tab] = true;
    },
    findChindCategory(tab, id) {
      http({
        url: "order/biz/category/getCategoryInfo",
        method: "post",
        parmes: { shopId: [], categoryId: id || "" },
      })
        .then((rps) => {
          this["categoryList" + tab] = rps.data.map((item) => {
            return item.categoryName;
          });
          rps.data.forEach((element) => {
            this["formList" + tab][element.categoryName] = element.categoryId;
          });
        })
        .catch((rps) => { });
    },
    getBrandData() {
      http({
        url: "order/bee/goods/shopBranch",
        method: "POST",
        parmes: {},
      }).then((rps) => {
        rps.data.forEach((element) => {
          this.branchNo = element.branchId
          this.branchList.push({
            brandName: element.branchName,
            id: element.branchId,
            select: false,
            isMainShop: element.isMainShop,
          });
        });

        // 超级蜜蜂，默认选中上次退出时选择的品牌，并在列表展示对应品牌的商品数据，首次进入默认选择和展示主店铺的数据
        if (this.isSuper) {
          http({
            url: "order/bees/superbees/selectBranchList",
            method: "post",
          }).then((res) => {
            if (res.code == 200) {
              if (res.data.branchIds) {
                var idsArr = res.data.branchIds;
              } else {
                var arrs = [];
                arrs.push(res.data.branchId);
                var idsArr = arrs;
              }
              // var idsArr = res.data.branchIds;
              this.branchList.forEach((item, index) => {
                idsArr.forEach((it) => {
                  if (item.id == it) {
                    this.$set(this.branchList[index], "select", true);
                  }
                });
              });
            }
          });
        }
      });
    },
    queryIsSuperBees() {
      http({
        url: "order/bees/bees/queryIsSuperBees",
        method: "get",
      })
        .then((rps) => {
          if (rps.code == 200) {
            this.isSuper = rps.data.super;
          }
        })
        .catch((rps) => { });
    },
    branchSelectFun(row) {
      this.branchList.forEach((element) => {
        if (row.id == element.id) {
          element.select = !element.select;
        }
      });
      // localStorage.setItem("branchList", JSON.stringify(this.branchList));
    },
    onStockSourceClick(item) {
      item.select = !item.select;
    },
    upselfClick(item) {
      item.select = !item.select;
    },
    onPublishItemClick(item, index) {
      // this.publishes.forEach((item, i) => item.select = i == index ? !item.select : false )
      item.select = !item.select;
    },
    resetFun() {
      this.categoryForm1 = { categoryName: "", id: "" };
      this.categoryList2 = [];
      this.categoryForm2 = { categoryName: "", id: "" };
      this.categoryList3 = [];
      this.formList3 = {};
      this.categoryForm3 = { categoryName: "", id: "" };
      this.branchList.forEach((element) => {
        element.select = false;
      });
      this.min = "";
      this.max = "";
    },
    setInputFun(min, max) {
      this.min = min;
      this.max = max;
    },
    emitFun() {
      if (this.min && this.max && Number(this.min) > Number(this.max)) {
        this.$toast("最低价不得高于最高价");
        return;
      }
      let str = [],
        myPublished = "n";
      this.branchList.forEach((element) => {
        if (element.select) {
          str.push(element.id);
        }
      });
      // this.publishes.forEach((item) => {
      //   if (item.select) myPublished = "y";
      // });
      let stockSource = this.stockSourceOpt.filter(v => v.select).map(v => v.key).join()
      let upShelf = this.upselfList.filter(v => v.select).map(v => v.key)
      if (upShelf.length ==2) {
        upShelf =''
      }
      upShelf = upShelf?upShelf[0]:upShelf
      let conditions = [
        ...this.conditions.map(v => ({ ...v, type: v.type.key, range: v.range.key })),
        ...this.inventoryList.map(v => ({ ...v, type: v.type.key, range: v.range.key }))
      ]
      let row = {
        branchNo: this.branchNo,
        priceRangeMin: this.min || "",
        priceRangeMax: this.max || "",
        anyCategoryId: this.categoryForm3.id || this.categoryForm2.id || this.categoryForm1.id || "",
        branchNoIn: str || "",
        myPublished: this.publishes[0].select ? "y" : "n",
        top: this.publishes[1].select ? 2 : "",

        ...this.form,
        promotionType: this.promotionTypeOpt.filter(v => v.select).map(v => v.key),
        conditions: conditions,
        stockSource: stockSource.length ? stockSource : 0,
        upShelf
      };
      stockSource
      this.$emit("callback", row);
      this.show = false;

      // 超级蜜蜂，默认选中上次退出时选择的品牌，并在列表展示对应品牌的商品数据，首次进入默认选择和展示主店铺的数据
      if (this.isSuper) {
        var branchIds = [];
        this.branchList.forEach((item) => {
          if (item.select || item.isMainShop) {
            branchIds.push(item.id);
          }
        });
        http({
          url: "order/bees/superbees/saveBranchList",
          method: "post",
          parmes: {
            branchIds: branchIds,
          },
        }).then((res) => {
          if (res.code == 200) {
          }
        });
      }
    },
  },
  created() {
    this.queryIsSuperBees();
    this.findChindCategory(1);
    // setTimeout(() => {
    this.getBrandData();
    // }, 500);
  },
  computed: {},
};
</script>
<style lang="less" scoped>
.popup-van {
  width: 675px;
}
button {
  outline: none;
  border: none;
  background: #fff;
  margin: 0;
  padding: 0;
}
.fen0 {
  padding-top: 100px;
  padding: 100px 31px 0 31px;
  height: calc(100% - 220px);
  overflow: auto;
}
.category {
  margin-top: 40px;
}
.filter-item {
  .fen1-2 {
    width: 170px !important;
  }
}
.fen1 {
  .fen1-1 {
    font-size: 28px;
    margin-bottom: 15px;
  }
  .fen1-2.add-btn {
    border-color: #f8a651;
    color: #f8a651;
  }
  .fen1-2 {
    position: relative;
    display: inline-block;
    width: 190px;
    height: 60px;
    line-height: 60px;
    background: #fff;
    color: #333;
    border: 2px solid #cccccc;
    border-radius: 10px;
    font-size: 24px;
    text-align: center;
    box-sizing: border-box;
    padding: 0 10px;
    img {
      position: absolute;
      right: 0;
      bottom: 0;
      z-index: 1;
      width: 38px;
      height: 38px;
      display: none;
      line-height: 0;
    }
    .sp1 {
      float: left;
      margin-left: 15%;
      width: 60%;
    }
    .sp2 {
      margin-right: 5%;
      height: 64px;
      line-height: 64px;
      text-align: right;
      float: right;
    }
  }
  .active {
    border-color: #ed3939;
    color: #ed3939;
    img {
      display: block;
    }
  }
  .ul {
    content: '';
    clear: both;
  }
  .ul > li {
    margin-right: 10px;
    margin-bottom: 30px;
    content: '';
    clear: both;
  }
  .ul > li:nth-child(3n + 3) {
    margin-right: 0;
  }
  .ul1 {
    max-height: 300px;
    overflow-y: auto;
  }
  .fen1-3 {
    display: flex;
    align-items: center;
    .fen1-3-1 {
      border-radius: 10px;
      font-size: 24px;
      background: #f2f2f2;
      /deep/input {
        text-align: center;
        height: 80px;
      }
      /deep/input::placeholder {
        color: #999999;
      }
    }
    .fen1-3-2 {
      font-size: 24px;
      color: rgba(153, 153, 153, 1);
      margin-left: 31px;
      margin-right: 31px;
    }
  }
  .fen1-4 {
    display: inline-block;
    width: 127px;
    height: 64px;
    line-height: 64px;
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    border: 2px solid #f8a651;
    font-size: 20px;
    color: #f8a651;
    text-align: center;
    box-sizing: border-box;
  }
}
.mr6 {
  // margin-top: 30px;
}
.mt-3 {
  margin-bottom: 30px;
}

.ffot {
  padding-left: 75px;
  // padding-right: 40px;
  padding-bottom: 46px;
  .f1 {
    width: 241px;
    height: 60px;
    line-height: 60px;
    background: rgba(255, 255, 255, 1);
    border-radius: 32px;
    border: 2px solid rgba(153, 153, 153, 1);
    font-size: 24px;
    color: #999999;
    margin-right: 30px;
    box-sizing: border-box;
  }
  .f2 {
    width: 245px;
    height: 64px;
    line-height: 64px;
    background: rgba(248, 213, 65, 1);
    border-color: rgba(248, 213, 65, 1);
    border-radius: 32px;
    font-size: 24px;
    columns: #333333;
    box-sizing: border-box;
  }
}
.navbar-fixed {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  padding-top: 20px;
  padding-bottom: 30px;
  text-align: center;
}
.index-popup-confirm .button {
  display: inline-block;
  width: 290px;
  height: 70px;
  border: 2px solid #999999;
  color: #999999;
  border-radius: 10px;
  box-sizing: border-box;
  font-size: 24px;
  text-align: center;
}
.index-popup-confirm .confirm {
  border: 0;
  background: linear-gradient(90deg, #ff8200 0%, #ff1414 100%);
  color: #fff;
  font-weight: bold;
  margin-left: 35px;
}
/deep/.van-cell {
  padding: 0;
}
/deep/.van-field__control {
  text-align: center;
}
.del-icon {
  width: 50px;
  height: 50px;
  margin-bottom: 30px;
  margin-left: 15px;
}
.num-popup {
  width: 80vw;
  height: 200px;
  text-align: center;
  .van-field {
    line-height: 80px;
  }
  /deep/.van-field__label {
    display: none;
  }
  button {
    margin-top: 20px;
    background: #ff8200;
    padding: 6px 10px;
  }
}
.open-view {
  text-align: center;
  background: #fffae4;
  color: #333333;
  font-size: 24px;
  border-radius: 10px;
  padding: 14px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  img {
    widows: 30px;
    height: 30px;
    margin-left: 8px;
  }
}
.ellipsis-input{
  width: 100%;
  border: none;
}
</style>
